import { useMutation } from "@tanstack/react-query";

import { downloadRdoPdf } from "@/adapters/api";

export function useDownloadRdoPdf(
	constructionId: string | undefined,
	rdoId: string | undefined,
) {
	return useMutation({
		mutationFn: async (fallbackFilename: string) => {
			if (!constructionId || !rdoId) throw new Error("missing rdo");
			const { blob, filename } = await downloadRdoPdf(
				constructionId,
				rdoId,
				fallbackFilename,
			);
			const url = URL.createObjectURL(blob);
			try {
				const anchor = document.createElement("a");
				anchor.href = url;
				anchor.download = filename;
				anchor.rel = "noopener";
				document.body.appendChild(anchor);
				anchor.click();
				anchor.remove();
			} finally {
				setTimeout(() => URL.revokeObjectURL(url), 10_000);
			}
			return filename;
		},
	});
}
